// CONNECTION FLOW ASSETS
import downloadAppIcon from 'assets/siteIntro/datrimony/icons/downloadApp.png'
import signupIcon from 'assets/siteIntro/datrimony/icons/signup.png'
import verificationIcon from 'assets/siteIntro/datrimony/icons/verification.png'
import connectIcon from 'assets/siteIntro/datrimony/icons/connect.png'
import attendesIcon from 'assets/siteIntro/datrimony/icons/attendes.png'

export const cpJourneyFeatures = [
    {
        mainText: 'QR Code Feature',
        subText: 'Instantly connect with members through personalized QR codes. Keep your network growing anytime, anywhere.',
        img: `${process.env.REACT_APP_CLOUDINARY_IMAGE_BASEURL_V1}CoupleSquad Static Assets/siteIntro/Datrimony/Features/oxrj2tqf4art6kw8ex6x`
    },
    {
        mainText: 'Couple Squad ID Card',
        subText: 'Access VIP events and exclusive offers with your personalized ID card',
        img: `${process.env.REACT_APP_CLOUDINARY_IMAGE_BASEURL_V1}CoupleSquad Static Assets/siteIntro/Datrimony/Features/awyq1jy4m6ojmnbooges`
    },
    {
        mainText: 'Cupid Feature',
        subText: 'Get matched with potential partners using our unique Cupid feature, adding an element of serendipity to your search',
        img: `${process.env.REACT_APP_CLOUDINARY_IMAGE_BASEURL_V1}CoupleSquad Static Assets/siteIntro/Datrimony/Features/ehkkrxtufysmnnukgjr9`
    },
    {
        mainText: 'Nearby Connect',
        subText: 'Find nearby eligible singles using Bluetooth technology for spontaneous connections.',
        img: `${process.env.REACT_APP_CLOUDINARY_IMAGE_BASEURL_V1}CoupleSquad Static Assets/siteIntro/Datrimony/Features/smh9ggtkfjnp3sgapujq`
    },
    {
        mainText: 'Find mutual Friends',
        subText: 'See which friends you have in common to make starting a conversation easier.',
        img: `${process.env.REACT_APP_CLOUDINARY_IMAGE_BASEURL_V1}CoupleSquad Static Assets/siteIntro/Datrimony/Features/itwghihc4rzn3alggfwd`
    },
    {
        mainText: 'Request Contact Info',
        subText: 'Seamlessly exchange contact details without missing out on potential matches',
        img: `${process.env.REACT_APP_CLOUDINARY_IMAGE_BASEURL_V1}CoupleSquad Static Assets/siteIntro/Datrimony/Features/pxsnvhyloeusmdsrptus`
    },
]

export const connectionFlow = [
    {
        img: downloadAppIcon,
        title: "Download the App",
        description: "Get the CoupleSquad app from the App Store or Google Play",
        subTitle: 'Start your journey by downloading the app to access all the features.'
    },
    {
        img: signupIcon,
        title: "Sign Up",
        description: "Set up your profile and choose the Connect membership.",
        subTitle: 'Build your profile to showcase who you are and what you’re looking for.'
    },
    {
        img: verificationIcon,
        title: "Verify your Profile",
        description: "Complete your profile and make sure it's verified.",
        subTitle: 'Verification helps us maintain a safe and genuine community.'
    },
    {
        img: connectIcon,
        title: "Engage & Connect with Members",
        description: "Engage with other members and enjoy all exclusive features and events.",
        subTitle: 'Use our features like QR codes and CoupleSquad Connect to find your potential match.'
    },
    {
        img: attendesIcon,
        title: "Attend our DTM Summit",
        description: "Meet your match in a friendly and memorable setting.",
        subTitle: 'Meet your match in a fun, memorable, and well-curated setting.'
    },
]

export const testimonialContentMarketing = [
    {
        img: `${process.env.REACT_APP_CLOUDINARY_IMAGE_BASEURL_V1}CoupleSquad Static Assets/siteIntro/Datrimony/Client_Testimonial/fsxvefpjuqfpwjeoxohl`,
        name: 'Priya & Rohan',
        location: 'UK',
        description: "We met at a CoupleSquad Summit, and it was magical. The event was perfectly organized, and we connected instantly. Grateful to CoupleSquad for bringing us together!"
    },
    {
        img: `${process.env.REACT_APP_CLOUDINARY_IMAGE_BASEURL_V1}CoupleSquad Static Assets/siteIntro/Datrimony/Client_Testimonial/lg4vx1fzf0cmxrhcdgfv`,
        name: 'Arjun',
        location: 'Bangalore',
        description: "The CoupleSquad Summit exceeded my expectations. Meeting people in person made all the difference. It’s the best way to connect with serious, like-minded individuals."
    },
    {
        img: `${process.env.REACT_APP_CLOUDINARY_IMAGE_BASEURL_V1}CoupleSquad Static Assets/siteIntro/Datrimony/Client_Testimonial/lqudgfil9gmszt4lvud8`,
        name: 'Anjali',
        location: 'Trivandrum',
        description: "Attending the women-only CoupleSquad event was the best decision! The atmosphere was so welcoming, and I made some amazing connections. Can’t wait for the next one!"
    },
]

export const partnered = [
    {
        key: 'curl360',
        img: `${process.env.REACT_APP_CLOUDINARY_IMAGE_BASEURL_V1}CoupleSquad Static Assets/siteIntro/Datrimony/Partnered/dgs5egcamutjflbstivi`,
        description: 'Get 250 Off on  SPA Services',
        offerDescription: `Unlock an exclusive ₹250 discount on spa services at Curls 360 Salon in Panampally Nagar, available once per month, exclusively for CoupleSquad Connect members!`
    },
    {
        key: 'hodByPrayana',
        img: `${process.env.REACT_APP_CLOUDINARY_IMAGE_BASEURL_V1}CoupleSquad Static Assets/siteIntro/Datrimony/Partnered/mfpqppyof6y7r8amgi4b`,
        description: 'Get Flat  250 0ff on your bill when you bring a date',
        offerDescription: `CoupleSquad Connect Members can now get ₹250 off their bill when they bring a date to Hang Out Destinations (HOD). Simply scan the QR code at the venue to claim your discount. Join today and enjoy exclusive benefits at our partnered spots!” The offer is valid once per month per producer`
    }
]